import classNames from 'classnames'

/**
 * Per-section loading and error states.
 *
 * The home page fetches three independent things. Whole-page spinners would
 * mean the whole screen waits on the slowest of them, and a single failed
 * query would blank sections that had already loaded fine.
 *
 * Note the failure mode this exists to avoid: `modules/funds/index.tsx` treats
 * "query errored" as "still loading" and spins forever, because it branches on
 * `!moneyPools` rather than on `isError`.
 */

export function PulseCard({ className }: { className?: string }) {
    return (
        <div
            className={classNames(
                'animate-pulse bg-white border border-divider rounded-card p-4',
                className
            )}
        >
            <div className="h-3 w-24 bg-divider rounded mb-3" />
            <div className="h-6 w-40 bg-divider rounded mb-4" />
            <div className="h-3 w-full bg-divider rounded mb-2" />
            <div className="h-3 w-2/3 bg-divider rounded" />
        </div>
    )
}

export function SectionError({
    onRetry,
    message = 'خطا در دریافت اطلاعات',
}: {
    onRetry?: () => void
    message?: string
}) {
    return (
        <div className="bg-white border border-divider rounded-card p-4 text-center">
            <p className="text-sm text-text-secondary">{message}</p>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="mt-2 text-sm text-green-1 font-bold cursor-pointer"
                >
                    تلاش مجدد
                </button>
            )}
        </div>
    )
}
